/* tslint:disable */
/* eslint-disable */
/**
 * Documents API
 * CDI Documents API
 *
 * The version of the OpenAPI document: 1.33.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists, mapValues } from '../runtime';
import { DocumentCreateFromJSON, DocumentCreateFromJSONTyped, DocumentCreateToJSON } from './DocumentCreate';
import { DocumentNewsCreateAllOfResourceFromJSON, DocumentNewsCreateAllOfResourceFromJSONTyped, DocumentNewsCreateAllOfResourceToJSON } from './DocumentNewsCreateAllOfResource';
import { DocumentNewsUpdateAllOfFromJSON, DocumentNewsUpdateAllOfFromJSONTyped, DocumentNewsUpdateAllOfToJSON } from './DocumentNewsUpdateAllOf';
import { DocumentStatusFromJSON, DocumentStatusFromJSONTyped, DocumentStatusToJSON } from './DocumentStatus';
/**
 * Check if a given object implements the DocumentNewsUpdate interface.
 */
export function instanceOfDocumentNewsUpdate(value) {
    let isInstance = true;
    return isInstance;
}
export function DocumentNewsUpdateFromJSON(json) {
    return DocumentNewsUpdateFromJSONTyped(json, false);
}
export function DocumentNewsUpdateFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        publisherId: !exists(json, 'publisherId') ? undefined : json['publisherId'],
        collectionId: !exists(json, 'collectionId') ? undefined : json['collectionId'],
        publicationDate: !exists(json, 'publicationDate')
            ? undefined
            : new Date(json['publicationDate']),
        languageId: !exists(json, 'languageId') ? undefined : json['languageId'],
        resource: !exists(json, 'resource')
            ? undefined
            : DocumentNewsCreateAllOfResourceFromJSON(json['resource']),
        status: !exists(json, 'status') ? undefined : DocumentStatusFromJSON(json['status'])
    };
}
export function DocumentNewsUpdateToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        publisherId: value.publisherId,
        collectionId: value.collectionId,
        publicationDate: value.publicationDate === undefined
            ? undefined
            : value.publicationDate.toISOString(),
        languageId: value.languageId,
        resource: DocumentNewsCreateAllOfResourceToJSON(value.resource),
        status: DocumentStatusToJSON(value.status)
    };
}
